import { Component, Element, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { FontType } from '@ugc-utils/utils';
import { LinedCheck } from '../../../../icons';

@Component({
  tag: 'ugc-review-verified-purchase',
  shadow: false,
})
export class UgcReviewVerifiedPurchase {
  @Element() el: HTMLElement;
  @Prop() verifiedPurchase: boolean = false;
  @Prop() fontType: FontType = FontType.large;

  render() {
    const { reviewStaticLanguage: { IDS_UGC_QNA_VERIFIED_PURCHASE = '' } = {} } = state;
    const fontType = this.fontType === FontType.large ? 'fs-14' : 'fs-12';

    return (
      this.verifiedPurchase && (
        <div class="flex-row-start-center gap-4">
          <LinedCheck width="16" height="16" />
          <span class={`${fontType} verified-text c-666`}>{IDS_UGC_QNA_VERIFIED_PURCHASE}</span>
        </div>
      )
    );
  }
}
